/**
 * Єдиний стандарт кнопок у ПОПАПАХ (затверджено юзером на SupportPopup,
 * 2026-06-15). Застосовується АБСОЛЮТНО в усіх попапах.
 *
 * Розташування: колонка по центру, всі кнопки однакової ширини (по
 * найширшій) — через `popupActionsCol` (mx-auto + w-fit + items stretch).
 * Кнопка: rounded-full, px-5 py-2.5, text-[0.8125rem], leading-none, gap-2,
 * іконка всередині ~16-17px.
 */

/** Контейнер групи кнопок: центрований, ширина = найширша кнопка. */
export const popupActionsCol = "mx-auto flex w-fit flex-col gap-2";

const base =
  "flex w-full items-center justify-center gap-2 rounded-full px-5 py-2.5 " +
  "font-display text-[0.8125rem] leading-none transition";

/** Оранжева головна кнопка. */
export const popupBtnPrimary =
  base + " bg-primary text-white font-bold active:bg-primary-deep";

/** Бежева вторинна (з бордером). */
export const popupBtnSecondary =
  base +
  " bg-surface-soft border border-ink/15 text-ink font-semibold shadow-card-soft active:scale-[0.98]";

/** Прозора (текстова) — напр. «Пізніше», «Скасувати». */
export const popupBtnGhost =
  base + " bg-transparent text-ink-dim font-semibold active:bg-ink/5";

/** Червона (небезпечна дія). */
export const popupBtnDanger =
  base + " bg-red-500 text-white font-bold active:bg-red-600";
